<template>
    <div>
        <v-card class="mt-8 mx-8 pa-4">
            <v-card-actions class="text-left">
                <v-row>
                    <v-col cols="12" class="text-left">
                        <v-icon class="back-link-icon" x-large @click="$router.push('/items/index')">mdi-arrow-left
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-card-title>اتصال فایل ها به درس</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="5">
                        <v-text-field v-model="needle" hint="شامل عنوان، مدت زمان، نوع فایل، توضیحات و کامنت"
                                      label="در  محتوای فایل جستجو کنید." color="black">
                        </v-text-field>
                    </v-col>
                    <v-col cols="5">
                        <v-select color="black" v-model="order" label="نوع ترتیب فایل ها را انتخاب کنید"
                                  :items="orderItems"
                                  item-text="name" @change="getFiles"></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="getFiles()" class="mt-4" elevation="0" color="info"
                               style="letter-spacing: normal!important">
                            جستجو
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                                align="center"
                                :single-expand="singleExpand"
                                :expanded.sync="expanded"
                                item-key="id"
                                show-expand
                                :headers="headers"
                                :items="files.data"
                                :items-per-page="10"
                                disable-sort
                                expand-icon="mdi-chevron-up"
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-spacer></v-spacer>
                                    <v-switch
                                            v-model="singleExpand"
                                            label="فقط یک سطر باز شود."
                                            class="mt-2"
                                    ></v-switch>
                                    <v-btn elevation="0" color="success" @click="assign()"
                                           style="letter-spacing: normal"
                                           class="mb-2 mx-16">تایید اتصال فایل ها به درس
                                    </v-btn>
                                </v-toolbar>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <v-row>
                                        <v-col cols="6">توضیحات :
                                            {{ item.description }}
                                        </v-col>
                                        <v-col cols="6">کامنت :
                                            {{ item.comment }}
                                        </v-col>
                                    </v-row>
                                </td>
                            </template>
                            <template
                                    v-slot:[`item.cover`]="{ item }">
                                <img :src="item.cover" height="150" width="150" :alt="item.title">
                            </template>
                            <template
                                    v-slot:[`item.select`]="{ item }">
                                <v-checkbox color="black" v-model="selectedFileIds[item.id]">
                                </v-checkbox>
                                <v-autocomplete :items="covers" item-text="tag" item-value="id"
                                                v-model="selectedFileCoverIds[item.id]"
                                                label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
                            </template>
                            <template
                                    v-slot:[`item.visibility`]="{ item }">
                                <span v-if="item.visibility">قابل مشاهده</span>
                                <span v-else>مخفی</span>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <v-pagination
                                class="text-center"
                                color="#696CFF"
                                v-model="files.current_page"
                                :length="files.last_page"
                                circle
                                @input="getFiles"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "ItemFileRelations",
    data() {
        return {
            covers: [],
            itemId: null,
            files: {
                current_page: 1
            },
            selectedFileIds: [],
            selectedFileCoverIds: [],
            expanded: [],
            singleExpand: false,
            headers: [
                {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
                {text: 'دسته بندی', value: 'category_name', align: 'center', width: '10%'},
                {text: 'عنوان', value: 'title', align: 'center', width: '8%'},
                {text: 'نوع فایل', value: 'mime_type', align: 'center', width: '8%'},
                {text: 'حجم', value: 'size', align: 'center', width: '8%'},
                {text: 'زمان', value: 'duration', align: 'center', width: '8%'},
                {text: 'وضعیت نمایش', value: 'visibility', align: 'center', width: '10%'},
                {text: 'اولویت', value: 'order', align: 'center', width: '3%'},
                {text: 'کاور', value: 'cover', align: 'center'},
                {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
                {text: 'انتخاب', value: 'select', align: 'right', width: '20%'},
            ],
            needle: null,
            orderItems: [
                {name: 'بر اساس دسته بندی', value: 'category_id'},
                {name: 'بر اساس وضعیت نمایش', value: 'visibility'},
                {name: 'بر اساس اولویت', value: 'order'},
                {name: 'بر اساس حجم', value: 'size'},
                {name: 'بر اساس زمان', value: 'duration'},
                {name: 'بر اساس نوع فایل', value: 'mime_type'},
                {name: 'بر اساس زمان ساخت', value: 'created_at'},
            ],
            order: 'created_at',
        }
    },
    methods: {
        getCovers() {
            window.axios.get('file-manager/cover/index?type=item_file&per_page=10000').then((res) => {
                this.covers = res.data.data.data
            })
        },
        getFiles() {
            let url = 'course/item-file/index?page=' + this.files.current_page ?? 1
            if (this.needle) {
                url = url + '&needle=' + this.needle
            }
            if (this.order) {
                url = url + '&order=' + this.order
            }
            window.axios.get(url).then((res) => {
                this.files = res.data.data
            })
        },
        getItemFiles() {
            window.axios.get('course/item/get-files/' + this.itemId).then((res) => {
                res.data.data.forEach((file) => {
                    this.$set(this.selectedFileIds, file.id, true)
                    this.$set(this.selectedFileCoverIds, file.id, file.cover_id)
                })
            })
        },
        assign() {
            console.log(this.selectedFileIds)
            console.log(this.selectedFileCoverIds, 'covers')
            window.axios.post('course/item/assign/' + this.itemId, {
                file_ids: this.selectedFileIds,
                cover_ids: this.selectedFileCoverIds
            }).then(() => {
                this.openSnackbar('فایل های انتخاب شده به درس متصل شد.', 'success')
            })
        }
    },
    mounted() {
        this.itemId = this.$route.params.id
        this.getFiles()
        this.getItemFiles()
        this.getCovers()
    }
}
</script>

<style scoped>

</style>